import React, { Component } from 'react';
import { ssSessionUtils } from '@bit/ui-common.ui-components/ss-utils';

const { logout, htmlStorage } = ssSessionUtils;

export default class AccountControlsManager extends Component {
    constructor(props) {
        super();
        for(let s in this.services)
            this.services[s] = this.services[s].bind(this);
    }

    state = {
        showAccountsModal: false
    }

    services = {
        toggleAccountModal: () => this.setState({...this.state,
            showAccountsModal: !this.state.showAccountsModal
        })
    }
}
